

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaMandateRoute', function () {

    return _squid.$ComponentRoute.extend('XOSepaMandateRoute', {
        name: 'sepaMandate',

        directive: 'xo-sepa-mandate',
        titleContent: 'directDebitAgreement.ddFullAgreementTitle',

        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js
// module chunks = 0